export default {
  houseKeeper: {
    reservationList: 'Danh sách đặt phòng',
    reservationInvoiceList: 'Danh sách hóa đơn của đặt phòng',
    reservationInfo: 'Thông tin đặt phòng',
    invoiceInfo: 'Thông tin hóa đơn',
    serviceList: 'Danh sách dịch vụ',
    operation: 'Hoạt động',
    roomTotal: 'Tổng hợp phòng',
    diff: 'Sai lệch',
    roomCleanStatus: 'Trạng thái dọn phòng',
    endDayReference: 'Đối chiếu cuối ngày'
  }
}
